import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { promoClient } from "@core/clients";

const useGetPromosQuery = (options: UseQueryOptions<any, any, any, any>) => {
  return useQuery(
    ["promos"],
    async () => {
      const data = await promoClient.getPromos();
      return data;
    },
    {
      ...options,
    }
  );
};

export default useGetPromosQuery;
